@import "styles/variables";

/*.delivered {
  background-color: var(--color-green-transparent);
}*/

.booking {
  border: 1px solid var(--color-grey);
  margin: 20px 0;
  border-radius: var(--background-border-radius);
}

.header {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;  
  padding: 10px;
  background-color: var(--color-lighter-grey-transparent);
}

.header button {
  padding-left: 10px;
  padding-right: 10px;
}

.text {
  font-family: var(--font-stack-default);
  font-size: var(--font-size-medium);
  color: var(--color-black-transparent);
  line-height: 22px;
}

.textsmall {
  font-family: var(--font-stack-default);
  font-size: var(--font-size-extra-small);
  color: var(--color-black-transparent);
  line-height: 1.2em;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;  
}

.status-row {
  display: flex;
}

.status-row, .toggle-row {
  border-top: 1px solid var(--color-grey);
  padding: 0 10px;
  line-height: 23px;
}

.col .text, .col .textsmall {
  padding-right: 10px;
}

.col:last-child .text, .col:last-child .textsmall  {
  padding-right: 0; 
}

.col100 {
  width: 100%;
}
.col55 {
  width: 55%;
}
.col50 {
  width: 50%;
}
.col45 {
  width: 45%;
}
.col35 {
  width: 35%;
}
.col30 {
  width: 30%;
}
.col25 {
  width: 25%;
}
.col20 {
  width: 20%;
}


.booking-content {
  border-top: 1px solid var(--color-grey);
  padding: 10px;
}

.booking-content h3 {
  margin-bottom: 2px;
}

.booking-content-columns {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
}

.confirmation-form {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--color-grey);
}

.email-field {
  flex: 1;
}

.send-button {
  margin-left: 15px;
}

.row {
}

.row + .row {
  margin-top: 10px;
}

.carType img {
  height: 20px;
  margin-top: -6px;  
}

.toggle-button {
  display: block; 
  width: 100%;
  text-align: left;
  line-height: 23px;
  cursor: pointer;
}

.toggle-button:focus {
  text-decoration: underline;
}

.icon {
  margin-right: 10px;
}
